module.exports = __webpack_public_path__ + "COBRApoint Instructions for Employers.pdf";